import React from 'react';

import useAppContext from '../../context/useAppContext';
import { ToastContext } from '@weezevent/nacre';
import useSeatedContext from '../../context/seatedContext';
import { useTranslation } from 'react-i18next';

import Loading from '../loading';

import Inventory from '../../models/inventory';

export default function InventoryManager({ children }) {
    const { t } = useTranslation();

    const [{ organization, event }] = useAppContext();

    const toast = React.useContext(ToastContext);
    const [loading, setLoading] = React.useState(true);

    if (!organization || !event) {
        throw new Error('[InventoryManager] No organization or event (for chart) set. Please check if you are using <InventoryManager> inside an organization/event related route');
    }

    const [{ inventory, inventories }, { setValue, setInventory }] = useSeatedContext();

    let _setInventory = React.useCallback(
        newInventory => {
            if (inventory) {
                return;
            }

            setInventory(newInventory);
        },
        [inventory, setInventory]
    );

    React.useEffect(() => {
        if (!inventory && inventories?.length) {
            _setInventory(inventories[0]);
        }
    }, [inventory, inventories, _setInventory]);

    const fetchInventories = React.useCallback(() => {
        // Gets all inventories and updates the context
        setLoading(true);
        Inventory.forEvent({ organizationId: organization.id, eventId: event.pk })
            .then(inventories => {
                setValue('inventories', inventories);
            })
            .catch(e => {
                toast(t('ticket.inventories.retrieval_error'));
            })
            .finally(() => {
                setLoading(false);
            });
    }, [event, organization, _setInventory, setLoading]);

    React.useEffect(() => {
        if (!event.use_sessions) {
            fetchInventories();
        } else {
            setLoading(false);
        }
    }, [event]);

    if (loading) {
        return <Loading />;
    }

    return !event.use_sessions ? children : null;
}
